import type StoreState from 'common/types/storeState';

export const captionSettingsSelector = (state: StoreState) => state.captionSettings;
